import {
  getCoachingCmsListRepo,
  getCoachingCmsCoursesRepo,
  getCoachingCmsExamsRepo,
  getCoachingCmsSubjectsRepo,
  getCoachingCmsCourseListRepo,
  postCmsCoachingOverviewRepo,
  getCmsCoachingLocationRepo,
  patchCmsCoachingOverviewRepo,
  getCoachingCmsMediaDropdownRepo,
  getCoachingCmsMediaRepo,
  UpdateCmsCoachingMediaRepo,
  UpdateCmsCoachingCourseRepo,
  postCmsCoachingTopperRepo,
  patchCmsCoachingTopperRepo,
  getCoachingNameRepo,
  postCmsCoachingCourseRepo,
  getCoachingToppersRepo,
  getCoachingInstituteRepo,
  postCoachingInstituteRepo,
  patchCoachingInstituteRepo,
  getCoachingDistrictRepo,
  deleteCoachingOtherMediaRepo,
  postCmsCoachingMediaImageRepo,
  DeleteCmsCoachingCourseRepo,
  postCmsCoachingCoursePublishRepo,
  postCmsCoachingPublishRepo
} from "../../repositories/premium/coaching";

export const getCmsCoachingList = (params) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_COACHING_LIST_REQUEST" });
    getCoachingCmsListRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_COACHING_LIST_SUCCESS",
            payload: response && response.data && response.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_COACING_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_COACING_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postCmsCoachingOverview = (data) => {
  return (dispatch) => {
    dispatch({ type: 'POST_CMS_COACHING_OVERVIEW_LOADING' })
    postCmsCoachingOverviewRepo(data)
      .then((response) => {
        if (response && response.status >= 200 && response.status <= 300) {
          dispatch({
            type: "POST_CMS_COACHING_OVERVIEW_SUCCESS",
            payload: response && response.data,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "POST_CMS_COACHING_OVERVIEW_FAILURE",
          payload: error.response && error.response.data || error.message,
        });
      });
  };
};

export const getCmsCoaching = (params) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_COACHING_REQUEST" });
    getCoachingCmsListRepo(params)
      .then((response) => {
        if (response && response.status >= 200 && response.status <= 300) {
          dispatch({
            type: "GET_CMS_COACHING_SUCCESS",
            payload: response && response.data && response.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_COACING_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_COACING_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsCoachingCoursesList = (params) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_COACHING_COURSES_LIST_REQUEST" });
    getCoachingCmsCoursesRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_COACHING_COURSES_LIST_SUCCESS",
            payload: response && response.data && response.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_COACHING_COURSES_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_COACHING_COURSES_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsCoachingExams = (params) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_COACHING_EXAMS_REQUEST" });
    getCoachingCmsExamsRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_COACHING_EXAMS_SUCCESS",
            payload: response && response.data && response.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_COACHING_EXAMS_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_COACHING_EXAMS_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsCoachingSubjects = (params) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_COACHING_SUBJECTS_REQUEST" });
    getCoachingCmsSubjectsRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_COACHING_SUBJECTS_SUCCESS",
            payload: response && response.data && response.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_COACHING_SUBJECTS_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_COACHING_SUBJECTS_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsCoachingCourseDropdownList = (params) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_COACHING_COURSE_DROPDOWN_LIST_REQUEST" });
    getCoachingCmsCourseListRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_COACHING_COURSE_DROPDOWN_LIST_SUCCESS",
            payload: response && response.data && response.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_COACHING_COURSE_DROPDOWN_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_COACHING_COURSE_DROPDOWN_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsCoachingCourse = (params) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_COACHING_COURSE_REQUEST" });
    getCoachingCmsCoursesRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_COACHING_COURSE_SUCCESS",
            payload: response && response.data && response.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_COACHING_COURSE_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_COACHING_COURSE_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsCoachingLocation = (params) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_COACHING_LOCATION_REQUEST" });
    getCmsCoachingLocationRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_COACHING_LOCATION_SUCCESS",
            payload: response && response.data && response.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_COACHING_LOCATION_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_COACHING_LOCATION_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsCoachingMediaDropdown = () => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_COACHING_MEDIA_DROPDOWN_REQUEST" });
    getCoachingCmsMediaDropdownRepo()
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_COACHING_MEDIA_DROPDOWN_SUCCESS",
            payload: response && response.data && response.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_COACHING_MEDIA_DROPDOWN_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_COACHING_MEDIA_DROPDOWN_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const patchCmsCoachingOverview = (data, id) => {
  return (dispatch) => {
    dispatch({ type: "PATCH_CMS_COACHING_OVERVIEW_LOADING", });
    patchCmsCoachingOverviewRepo(data, id)
      .then((response) => {
        if (response && response.status >= 200 && response.status <= 300) {
          dispatch({
            type: "PATCH_CMS_COACHING_OVERVIEW_SUCCESS",
            payload: response?.data,
          });
        } else {
          dispatch({
            type: "PATCH_CMS_COACHING_OVERVIEW_FAILURE",
            payload: response?.data,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "PATCH_CMS_COACHING_OVERVIEW_FAILURE",
          payload: error?.response?.data || error?.message
        });
      });
  };
};

export const getCmsCoachingMedia = (params) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_COACHING_MEDIA_REQUEST" });
    getCoachingCmsMediaRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_COACHING_MEDIA_SUCCESS",
            payload: response && response.data && response.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_COACING_MEDIA_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_COACING_MEDIA_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postCmsCoachingMedia = (params, body) => {
  return (dispatch) => {
    UpdateCmsCoachingMediaRepo(params, body)
      .then((response) => {
        if (response && response.status >= 200 && response.status <= 300) {
          dispatch({
            type: "UPDATE_CMS_COACHING_MEDIA_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "UPDATE_CMS_COACHING_MEDIA_FAILURE",
            payload: error.response && error.response.data || error.message,
          });
        }
      });
  };
};

export const UpdateCmsCoachingCourse = (params, body) => {
  return (dispatch) => {
    dispatch({ type: "UPDATE_CMS_COACHING_COURSE_LOADING" });
    UpdateCmsCoachingCourseRepo(params, body)
      .then((response) => {
        if (response && response.status >= 200 && response.status <= 300) {
          dispatch({
            type: "UPDATE_CMS_COACHING_COURSE_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "UPDATE_CMS_COACHING_COURSE_FAILURE",
            payload: error.response && error.response.data || error.message,
          });
        }
      });
  };
};

export const postCmsCoachingTopper = (data, id) => {
  return (dispatch) => {
    dispatch({ type: 'POST_CMS_COACHING_TOPPER_LOADING' })
    postCmsCoachingTopperRepo(data, id)
      .then((response) => {
        if (response && response.status >= 200 && response.status <= 300) {
          dispatch({
            type: "POST_CMS_COACHING_TOPPER_SUCCESS",
            payload: response && response.data,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "POST_CMS_COACHING_TOPPER_FAILURE",
            payload: error.response && error.response.data || error.message,
          });
        }
      });
  };
};
export const getCmsCoachingName = (params) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_COACHING_NAME_REQUEST" });
    getCoachingNameRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_COACHING_NAME_SUCCESS",
            payload: response && response.data && response.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_COACHING_NAME_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_COACHING_NAME_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postCmsCoachingCourse = (body) => {
  return (dispatch) => {
    dispatch({ type: "POST_CMS_COACHING_COURSE_LOADING" })
    postCmsCoachingCourseRepo(body)
      .then((response) => {
        if (response && response.status >= 200 && response.status <= 300) {
          dispatch({
            type: "POST_CMS_COACHING_COURSE_SUCCESS",
            payload: response && response.data && response.data,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "POST_CMS_COACHING_COURSE_FAILURE",
            payload: error.response && error.response.data || error.message,
          });
        }
      });
  };
};
export const DeleteCmsCoachingCourse = (params) => {
  return (dispatch) => {
    dispatch({ type: "DELETE_CMS_COACHING_COURSE_LOADING" })
    DeleteCmsCoachingCourseRepo(params)
      .then((response) => {
        if (response && response.status >= 200 && response.status <= 300) {
          dispatch({
            type: "DELETE_CMS_COACHING_COURSE_SUCCESS",
            payload: response && response.data && response.data,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "DELETE_CMS_COACHING_COURSE_FAILURE",
          payload: error.response && error.response.data || error.message,
        });
      });
  };
};

export const patchCmsCoachingTopper = (params, data) => {
  return (dispatch) => {
    patchCmsCoachingTopperRepo(params, data)
      .then((response) => {
        if (response && response.status >= 200 && response.status <= 300) {
          dispatch({
            type: "PATCH_CMS_COACHING_TOPPER_SUCCESS",
            payload: response?.data,
          });
        } else {
          dispatch({
            type: "PATCH_CMS_COACHING_TOPPER_FAILURE",
            payload: response?.data,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "PATCH_CMS_COACHING_TOPPER_FAILURE",
            payload: error?.data && error.response.data || error.message || error.response,
          });
        }
      });
  };
};

export const getCmsCoachingToppers = (params) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_COACHING_TOPPERS_REQUEST" });
    getCoachingToppersRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_COACHING_TOPPERS_SUCCESS",
            payload: response && response.data && response.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_COACING_TOPPERS_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "GET_CMS_COACING_TOPPERS_FAILURE",
          payload: error && error,
        });
      });
  };
};

export const getCmsCoachingInstitute = (params) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_COACHING_INSTITUTE_REQUEST" });
    getCoachingInstituteRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_COACHING_INSTITUTE_SUCCESS",
            payload: response && response.data && response.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_COACING_INSTITUTE_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "GET_CMS_COACING_INSTITUTE_FAILURE",
          payload: error && error,
        });
      });
  };
};

export const postCmsCoachingInstitute = (body) => {
  return (dispatch) => {
    dispatch({ type: "POST_CMS_COACHING_INSTITUTE_LOADING" })
    postCoachingInstituteRepo(body)
      .then((response) => {
        if (response && response.status >= 200 && response.status <= 300) {
          dispatch({
            type: "POST_CMS_COACHING_INSTITUTE_SUCCESS",
            payload: response && response.data,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "POST_CMS_COACHING_INSTITUTE_FAILURE",
          payload: error.response && error.response.data || error.message,
        });
      });
  };
};

export const patchCmsCoachingInstitute = (params, body) => {
  return (dispatch) => {
    patchCoachingInstituteRepo(params, body)
      .then((response) => {
        if (response && response.status >= 200 && response.status <= 300) {
          dispatch({
            type: "PATCH_CMS_COACHING_INSTITUTE_SUCCESS",
            payload: response?.data,
          });
        } else {
          dispatch({
            type: "PATCH_CMS_COACHING_INSTITUTE_FAILURE",
            payload: response?.data,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "PATCH_CMS_COACHING_INSTITUTE_FAILURE",
            payload: error?.data && error.response.data || error.message || error.response,
          });
        }
      });
  };
};

export const getCmsCoachingDistrict = (params) => {
  return (dispatch) => {
    dispatch({ type: "GET_COACHING_DISTRICT_REQUEST" });
    getCoachingDistrictRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_COACHING_DISTRICT_SUCCESS",
            payload: response && response.data && response.data,
          });
        } else {
          dispatch({
            type: "GET_COACHING_DISTRICT_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_COACHING_DISTRICT_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const deleteCoachingOtherMedia = (params) => {
  return (dispatch) => {
    deleteCoachingOtherMediaRepo(params)
      .then((response) => {
        if (response && response.status >= 200 && response.status <= 300) {
          dispatch({
            type: "DELETE_COACHING_OTHER_MEDIA_SUCCESS",
            payload: response?.data?.data,
          });
        } else {
          dispatch({
            type: "DELETE_COACHING_OTHER_MEDIA_FAILURE",
            payload: response?.data,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "DELETE_COACHING_OTHER_MEDIA_FAILURE",
            payload: error?.data,
          });
        }
      });
  };
};

export const postCmsCoachingMediaImage = (params, body) => {
  return (dispatch) => {
    postCmsCoachingMediaImageRepo(params, body)
      .then((response) => {
        if (response && response.status >= 200 && response.status <= 300) {
          dispatch({
            type: "POST_MEIDA_IMAGE_SUCCESS",
            payload: response && response.data && response.data,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "POST_MEIDA_IMAGE_FAILURE",
            payload: error.response && error.response.data || error.message,
          });
        }
      });
  };
};

export const postCmsCoachingCoursePublish = (params, body) => {
  return (dispatch) => {
    dispatch({ type: 'POST_COURSE_PUBLISH_LOADING' })
    postCmsCoachingCoursePublishRepo(params, body)
      .then((response) => {
        if (response && response.status >= 200 && response.status <= 300) {
          dispatch({
            type: "POST_COURSE_PUBLISH_SUCCESS",
            payload: (response && response.data) || { updated: 'ok' },
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "POST_COURSE_PUBLISH_FAILURE",
          payload: error.response && error.response.data || error.message,
        });
      });
  };
};

export const postCmsCoachingPublish = (params, body) => {
  return (dispatch) => {
    dispatch({ type: 'POST_COACHING_PUBLISH_LOADING' })
    postCmsCoachingPublishRepo(params, body)
      .then((response) => {
        if (response && response.status >= 200 && response.status <= 300) {
          dispatch({
            type: "POST_COACHING_PUBLISH_SUCCESS",
            payload: response && response.data && response.data,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "POST_COACHING_PUBLISH_FAILURE",
          payload: error.response && error.response.data || error.message,
        });
      });
  };
};
